import { API, errorOf } from '../hermes';

export const EXECUTOR_KEY = 'agent_bench';
export const TEMPLATE_NAME = 'Agent bench';
export function caseFrom(c, i) {
  return {
    kind: 'case', label: String(c.label || `case ${i + 1}`), description: String(c.description || ''),
    prompt: String(c.prompt || ''),
    hats: String(c.hats || ''),
    rubric: String(c.rubric || ''), tenant: String(c.tenant || ''), source_session: String(c.source_session || ''),
    source_run: c.source_run || null,
  };
}

export async function findBench(axios) {
  const { data } = await axios.get(`${API}/console/bench/`);
  return { executor: data.executor, template: data.template, tenantSlug: data.tenant_slug, tenantName: data.tenant_name,
    defaultModel: data.default_model, defaultReasoning: data.default_reasoning };
}

export function onBench(bench, config = {}) {
  return { ...config, excludeTenantSlug: true, params: { ...(config.params || {}), tenant_slug: bench.tenantSlug } };
}

export function casesOf(template) {
  return (template?.inputs || []).filter((x) => x.kind === 'case').map(caseFrom);
}

export async function saveCases(axios, bench, cases) {
  const others = (bench.template.inputs || []).filter((x) => x.kind !== 'case');
  const { data } = await axios.patch(`${API}/templates/${bench.template.id}/`, { inputs: others.concat(cases.map(caseFrom)) }, onBench(bench));
  return data;
}

export function paramsLine(run) {
  const p = run.params || {};
  const bits = [];
  if (p.model) bits.push(p.model);
  if (p.reasoning) bits.push(p.reasoning);
  if (p.hats) bits.push(`hats ${p.hats}`);
  if (p.only) bits.push(`only ${p.only}`);
  return bits.join(' · ') || 'defaults';
}

export function progressLine(run) {
  const pr = run.progress || {};
  if (!pr.units) return '';
  return `${pr.done ?? 0} of ${pr.units} ran${pr.failed ? ` · ${pr.failed} failed to run` : ''}`;
}

export { errorOf };
